import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import AdminClientsSettingsSection from "./sections/adminClientsSettingsSection";
import AdminClientsRegionsSection from "./sections/adminClientsRegionsSection";
import AdminClientsInfoSection from "./sections/adminClientsInfoSection";
import AdminClientsSection from "./sections/adminClientsSection";
import AdminRolesSection from "./sections/adminRolesSection";
import AdminUrersSection from "./sections/adminUrersSection";
import { IUserOptions } from "../../types/interfaces";

function AccessRightsApp() {
  const { data } = useSelector((state: IUserOptions) => state.user.user);

  return (
    <Routes>
      {!data.isCustomer && (
        <>
          <Route path="/roles" element={ (data.claims.includes('admin') || data.claims.includes('role:claim:change')) ? <AdminRolesSection /> : <Navigate to="/login"/>} />
          <Route path="/users" element={<AdminUrersSection />} />
          <Route path="/customers" element={<AdminClientsSection />} />
          <Route element={<AdminClientsInfoSection />} path="/customers/info/:id"/>
          <Route element={<AdminClientsSettingsSection />} path="/customers/settings/:id"/>
          <Route element={<AdminClientsRegionsSection />} path="/customers/regions/:id"
          />
        </>
      )}
    </Routes>
  );
}

export default AccessRightsApp;
